import * as React from 'react';
import styles from '../styles/wizards/AddFileWizard.scss';
import AddDocumentIcon from '../assets/images/add-document-60x60.svg';
import { __, setTableParams } from '../core/utils';
import AddFileForm from '../forms/add_file_wizard/AddFileForm';
import { withRouter } from 'react-router';
import { listFiles, uploadFiles } from '../redux/actions/table/files';
import { setNotification } from '../redux/actions/general/notification';

const AddFileWizard = ({ match, onClose }) => {
  const _handleSubmit = (formData) => {
    const stage_id = match.params.stage;
    const files = formData.files || [];

    return uploadFiles(stage_id, files).then(() => {
      listFiles(stage_id);
      setTableParams('files', {
        folders_reload_at: Date.now(),
      });
      setNotification(__('files.notification.uploaded', {}, 'Files uploaded.'));

      if (onClose) {
        onClose();
      }
    });
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('files.add-file-wizard.title')}</span>
          <span>{__('files.add-file-wizard.subtitle')}</span>
        </div>
        <div className={styles.right}>
          <AddDocumentIcon />
        </div>
      </div>
      <div className={styles.body}>
        <AddFileForm onSubmit={_handleSubmit} onClose={onClose} />
      </div>
    </>
  );
};

export default withRouter(AddFileWizard);
